import styled from '@emotion/styled';

import { ItemsTable as BaseTable } from 'components';

export const Title = styled.h1`
  font-size: 2.6rem;
  font-weight: normal;
  margin: 0 0 1.43rem;
`;

export const TotalPrice = styled.div`
  width: 100%;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  text-align: right;
  margin-top: 4rem;
`;

export const Table = styled(BaseTable)`
  th:first-of-type {
    width: 70%;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem 0 0.7rem 2.42rem;
`;

export const MaximumExceededMessage = styled.p`
  max-width: 400px;
  margin-left: 30px;
  color: ${({ theme }) => theme.colors.danger};
`;
